var map = {
	"./Omega Application.png": 1163,
	"./Rahatak Application.png": 1164,
	"./apicbase application.png": 1165,
	"./loyverse application.png": 1166,
	"./marn.svg": 493,
	"./salla application.png": 1167,
	"./zid application.png": 1168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 658;